/* unplugin-vue-components disabled */import script from "./FriendlyReminder.vue?vue&type=script&lang=ts&setup=true"
export * from "./FriendlyReminder.vue?vue&type=script&lang=ts&setup=true"

import "./FriendlyReminder.vue?vue&type=style&index=0&id=4fcc02da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fcc02da"]])

export default __exports__